// Cliente da API: cookie de sessão, cabeçalho X-BF-Client nas escritas e erros RFC 9457.
export const API_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:3333";
export const WS_URL = API_URL.replace(/^http/, "ws");

export interface Problem {
  type?: string;
  title?: string;
  status: number;
  detail?: string;
  code: string;
  issues?: { path: string; message: string }[];
  [key: string]: unknown;
}

export class ApiError extends Error {
  constructor(public readonly problem: Problem) {
    super(problem.detail ?? problem.title ?? problem.code);
  }
  get code() {
    return this.problem.code;
  }
  get status() {
    return this.problem.status;
  }
}

type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

async function request<T>(method: Method, path: string, body?: unknown): Promise<T> {
  const headers: Record<string, string> = {};
  if (method !== "GET") headers["X-BF-Client"] = "web";
  if (body !== undefined) headers["Content-Type"] = "application/json";
  let res: Response;
  try {
    res = await fetch(`${API_URL}${path}`, {
      method,
      credentials: "include",
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError({
      status: 0,
      code: "network_error",
      detail: "Sem conexão com o servidor. Confira a internet e tente de novo.",
    });
  }
  const text = await res.text();
  const data = text ? safeParse(text) : null;
  if (!res.ok) {
    const problem = (data && typeof data === "object" ? data : {}) as Partial<Problem>;
    throw new ApiError({
      status: res.status,
      code: problem.code ?? "error",
      ...problem,
    } as Problem);
  }
  return data as T;
}

function safeParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export const api = {
  get: <T>(path: string) => request<T>("GET", path),
  post: <T>(path: string, body?: unknown) => request<T>("POST", path, body ?? {}),
  put: <T>(path: string, body?: unknown) => request<T>("PUT", path, body ?? {}),
  patch: <T>(path: string, body?: unknown) => request<T>("PATCH", path, body ?? {}),
  delete: <T>(path: string) => request<T>("DELETE", path),
};

export function errorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.problem.issues?.length)
      return `${e.message} (${e.problem.issues.map((i) => i.path || i.message).join(", ")})`;
    return e.message;
  }
  return "Algo deu errado. Tente de novo.";
}

export function qs(params: Record<string, string | number | undefined | null>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params))
    if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
  const s = p.toString();
  return s ? `?${s}` : "";
}
